import script from "./UserGoalList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserGoalList.vue?vue&type=script&setup=true&lang=ts"

import "./UserGoalList.vue?vue&type=style&index=0&id=67bd6daa&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67bd6daa"]])

export default __exports__